import { FETCH_RESERVATION_COMPLETED } from 'Rentlio/state/types'
import createReducer from 'Rentlio/state/utils/createReducer'

const reservation = createReducer({})({
  [FETCH_RESERVATION_COMPLETED]: (_, { payload }) => ({ ...payload })
})

export default reservation
